import {startsWith, memoize} from 'lodash';
import {ResourceType, RequestParameters} from 'mapbox-gl';

export default memoize(
    glyphMap => (url: string, resourceType: ResourceType): RequestParameters => {
        if (resourceType === 'Glyphs' && startsWith(url, 'g://')) {
            const parts = url.replace('g://', '').split('/');
            const [uniqueTilecacheKey, fontstack] = parts[0].split('__');
            const glyphUrl = glyphMap[uniqueTilecacheKey];

            return {url: glyphUrl.replace('{fontstack}', fontstack).replace('{range}', parts[1])};
        } else if (resourceType === 'Tile' && (
            startsWith(url, 'https://privatetiles.gaiagps.com') ||
            startsWith(url, `${window.location.origin}/api/tiles`)
        )) {
            return {url: url, credentials: 'include'};
        } else {
            return {url: url};
        }
    }
);
